import Vue from 'vue'
import Vuex from 'vuex'
import authentication from '@/store/modules/authentication'
import coprops from '@/store/modules/coprops'
import survoyor from '@/store/modules/survoyor'
import mailing from '@/store/modules/mailing'
import sessions from '@/store/modules/sessions'

import serviceProvider from '@/store/modules/serviceProvider'
import siteManagement from '@/store/modules/siteManagement'
import rateManagement from '@/store/modules/rateManagement'
import superAdminDashboard from '@/store/modules/superAdminDashboard'

import meterReset from './modules/meterReset'
import logs from './modules/logs'
import sitePreferences from './modules/sitePreferences'



import ApiServices from '@/services/api'

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    project: 'Utility'
  },

  getters: {
    projectName: state => {
      return state.project
    }
  },

  actions: {
    FILE_UPLOAD: ({}, config) => {
      return ApiServices.fileUpload(config).then((response)=>{
        console.log(response)
        return response;
      }).catch((err)=>{
        return err;
      })
    },
  },

  modules: {
    authentication,
    serviceProvider,
    siteManagement,
    rateManagement,
    superAdminDashboard,
    
    coprops,
    survoyor,
    mailing,
    sessions,
    meterReset,
    logs,
    sitePreferences

  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js